export enum UserRoles {
  SupportUser = 'supportUser',
  ComplianceUser = 'complianceUser',
}
